/** Shared wire alphabet; explicit prose labels must not replace an existing specific code. */
export const isRefusalCode = (value: string): boolean => /^[a-z0-9_:.,*/-]+$/.test(value);

/** Reviewed words from engine codes and layer/type names. Never extend this from event input. */
export const REFUSAL_PROSE_WORDS = Object.freeze([
    'action', 'actor', 'ap', 'armed', 'available', 'boundary', 'browser', 'cannot', 'cast', 'catalog',
    'combat', 'creature', 'damage', 'dispatch', 'door', 'effect', 'entity', 'error', 'failed', 'fetch',
    'geometry', 'gm', 'held', 'inventory', 'landing', 'loaded', 'lock', 'missing', 'modeled', 'not',
    'object', 'pending', 'perception', 'points', 'projection', 'range', 'refused', 'resolve', 'resolved',
    'resource', 'save', 'size', 'skipped', 'status', 'support', 'target', 'teleport', 'trade',
    'unavailable', 'unported', 'unresolved', 'weapon',
] as const);
